import { render, staticRenderFns } from "./FrzChamberPicking.vue?vue&type=template&id=23791418"
import script from "./FrzChamberPicking.vue?vue&type=script&lang=js"
export * from "./FrzChamberPicking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports